import React, { useState } from 'react';
import { FactCheck as FactCheckIcon } from '@mui/icons-material';
import { Button, enqueueSnackbar, Typography } from '../../design-system';
import {
  useInventoryQuery,
  useCompleteEmployeeInventoryMutation,
  useCallBackOnBack,
} from '../../hooks';
import {
  CloseIconButton,
  DashboardHeader,
  DashboardInputs,
  DashboardPopup,
  DashboardWrapper,
} from '../dashboard';
import { momentTextFormat } from '../../utils';
import { InventoryGetAllQuery } from '../../types';
import { MESSAGES } from '../../const';
import { useNavigate } from 'react-router-dom';

export const Inventory = () => {
  const { mutate } = useCompleteEmployeeInventoryMutation();
  const navigate = useNavigate();

  const [isOpenCompletePopup, setIsOpenCompletePopup] = useState(false);
  const [selectedItem, setSelectedItem] = useState<InventoryGetAllQuery['data'][number]>({
    id: '',
    yardName: '',
    createdAt: '',
  });

  const { data = { data: [], totalCount: 0 }, refetch } = useInventoryQuery();

  const handleItemClick = (item: any) => {
    navigate(`/dashboard/inventory/${item.id}/check`);
  };

  const handleOpenCompleteClick = (item: any) => {
    setSelectedItem(item);
    setIsOpenCompletePopup(true);
  };

  useCallBackOnBack(() => setIsOpenCompletePopup(false), isOpenCompletePopup);

  const handleCompleteClick = () => {
    mutate(
      { id: selectedItem.id },
      {
        onSuccess: () => {
          setIsOpenCompletePopup(false);
          enqueueSnackbar(MESSAGES.INVENTORY.SUCCESS.COMPLETED, 'success');
          refetch();
        },
      },
    );
  };

  return (
    <DashboardWrapper rows={'initial'}>
      <DashboardInputs columns={'1fr max-content'}>
        {data.data.map((item) => (
          <React.Fragment key={item.id}>
            <Button size={'medium'} onClick={() => handleItemClick(item)}>
              {momentTextFormat(item.createdAt)}
            </Button>
            <Button onClick={() => handleOpenCompleteClick(item)} isSquare>
              <FactCheckIcon />
            </Button>
          </React.Fragment>
        ))}
      </DashboardInputs>
      <DashboardPopup isOpen={isOpenCompletePopup}>
        <DashboardHeader>
          <Typography variant={'textXL'} weight={'bold'}>
            Finish: {momentTextFormat(selectedItem.createdAt, true)}
          </Typography>
          <CloseIconButton onClick={() => setIsOpenCompletePopup(false)} />
        </DashboardHeader>
        <span></span>
        <Button size={'medium'} onClick={handleCompleteClick}>
          Submit
        </Button>
      </DashboardPopup>
    </DashboardWrapper>
  );
};
